export default "__VITE_ASSET__aeasZxsx__"